module.exports = __webpack_public_path__ + "media/images/emprelatam-logo-invertido-transparente-52512935.png";